import { SearchX } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { Button } from '@/components/ui/Button';
import { EmptyState } from '@/components/ui/EmptyState';
import { type } from '@/theme/typography';

/**
 * An address the app has no screen for — a typo, an old bookmark, a link to something that moved.
 *
 * It is a **route**, not a fallthrough: without one, react-router renders its own developer error
 * page and the whole app disappears with it. This says the same thing in the product's words, keeps
 * the shell around it, and offers the one screen that is certain to exist (§8: a state is not a
 * dead end).
 */
export default function NotFound() {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  return (
    <>
      <h1 className={type.pageTitle}>{t('notFoundTitle')}</h1>
      <EmptyState
        className="mt-10"
        icon={SearchX}
        message={t('notFound')}
        action={
          <Button variant="secondary" onClick={() => void navigate('/')}>
            {t('backToDashboard')}
          </Button>
        }
      />
    </>
  );
}
